








import Vue from 'vue'
import { PropValidator, RenderContext } from 'vue/types/options'
import IgIcon from '@/components/IgIcon.vue'
import { extender_vendor_t } from '@/types/api'
type direction_t = 'left' | 'right'
export default Vue.extend({
  components: {
    IgIcon
  },
  props: {
    vendor: {
      type: String
    } as PropValidator<extender_vendor_t>,
    side: {
      type: String,
      default: 'left'
    } as PropValidator<direction_t>
  },
  computed: {
    label (): string {
      // return `ig-${this.type.toLowerCase()}-${this.side.toLowerCase()}-side`
      return this.vendor === 'Aspeed' ? 'HG' : 'HX'
    },
    tooltip (): string { return this.vendor === 'Aspeed' ? '1 G' : '10 G' }
  }
})
